<script setup lang="ts">
import Button from '@ui/components/button/Button.vue'
import Icon from '@ui/components/icon/Icon.vue'
import IconButton from '@ui/components/icon/IconButton.vue'
import { NotificationKind } from '@ui/components/notifications/useNotifications'
import { ButtonVariant, Sizes } from '@ui/styles'
import CheckCircle from '~icons/cue-filled/check-circle'
import ExclamationCircle from '~icons/cue-filled/exclamation-circle'
import InfoCircle from '~icons/cue-filled/info-circle'
import TriangleExclamation from '~icons/cue-filled/triangle-exclamation'
import Times from '~icons/cue-regular/times'

const props = withDefaults(
  defineProps<{
    title?: string
    description?: string
    action?: boolean
    kind?: string
  }>(),
  {
    title: '',
    description: '',
    action: false,
    kind: NotificationKind.Informative,
  },
)

defineEmits(['close'])

function getIconByKind() {
  switch (props.kind) {
    case NotificationKind.Positive:
      return CheckCircle
    case NotificationKind.Warning:
      return ExclamationCircle
    case NotificationKind.Negative:
      return TriangleExclamation
    default:
      return InfoCircle
  }
}
</script>

<template lang="pug">
.notification.flex.col-16.br-16.p-16.max-w-374(:class="kind")
  .flex.row-16
    Icon.icon.s-24(:name="getIconByKind()")
    .text.flex-center-start.col-4.w-100p
      .typ-16-24-500(v-if="title") {{ $t(title || '') }}
      .typ-14-20-400(v-if="description") {{ $t(description || '') }}
    IconButton.close-icon(:name="Times" :variant="ButtonVariant.Function" :size="Sizes.R2D2" @click="$emit('close')")
  .flex-end-center(v-if="action")
    Button(label="Action" :variant="ButtonVariant.Secondary" :size="Sizes.Leia")
</template>

<style scoped>
.notification {
  background: var(--cue-bg-neutral-inverse);

  &.informative {
    .icon {
      color: var(--cue-content-info-on-inverse);
    }
  }

  &.positive {
    .icon {
      color: var(--cue-content-success-on-inverse);
    }
  }

  &.warning {
    .icon {
      color: var(--cue-content-accent-on-inverse);
    }
  }

  &.negative {
    .icon {
      color: var(--cue-content-error-on-inverse);
    }
  }

  &.secondary {
    .icon {
      color: var(--cue-content-neutral-on-inverse-secondary);
    }
  }
}

.text {
  color: var(--cue-content-neutral-on-inverse);
}

.close-icon.function.r2d2:not(:disabled) {
  --icon-color: var(--cue-content-neutral-on-inverse);
}
</style>
